<template>
<md-card>
    <header-form title="EDITAR DE PERMISSÕES" :rota="{name: 'permissaoRead'}" tooltip="Lista de Usuários" />
    <form @submit.prevent="update">
        <md-card-content>
            <div class="md-layout">
                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.nome }">
                        <label>NOME</label>
                        <md-input v-model="dados.nome" type="text" class="uppercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.nome">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.nome" class="validErro"> {{ errors.nome[0] }}</div>
                </div>

                <div class="md-layout-item md-size-60 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.descricao }">
                        <label>DESCRIÇÃO</label>
                        <md-input v-model="dados.descricao" type="text" class="uppercase"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.descricao">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.descricao" class="validErro"> {{ errors.descricao[0] }}</div>
                </div>
            </div>

            <div class="md-layout">
                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <md-autocomplete class="uppercase" :class="{ 'md-error': errors.grupo_permissao_id }" v-model="grupo" :md-options="grupos" @md-changed="autoCompleteGrupo" @md-opened="autoCompleteGrupo" @md-selected="getSelectedGrupo">
                        <label>GRUPO</label>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.grupo_permissao_id">close</md-icon>
                        </slide-y-down-transition>
                    </md-autocomplete>
                    <div v-if="errors.grupo_permissao_id" class="validErro"> {{ errors.grupo_permissao_id[0] }}</div>
                </div>

                <div class="md-layout-item md-size-40 md-xsmall-size-100">
                    <md-field :class="{ 'md-error': errors.link }">
                        <label>LINK</label>
                        <md-input v-model="dados.link"> </md-input>
                        <slide-y-down-transition>
                            <md-icon class="error" v-show="errors.link">close</md-icon>
                        </slide-y-down-transition>
                    </md-field>
                    <div v-if="errors.link" class="validErro"> {{ errors.link[0] }}</div>
                </div>

                <div class="md-layout-item md-size-20 md-xsmall-size-100">
                    <md-field>
                        <label>DESENVOLVEDOR</label>
                        <md-select v-model="dados.desenvolvedor" name="pages">
                            <md-option value="1">SIM</md-option>
                            <md-option value="0">NÃO</md-option>
                        </md-select>
                    </md-field>
                </div>
            </div>
        </md-card-content>

        <md-card-actions>
            <md-button type="submit" class="md-success md-round">
                <span class="md-label">
                    <md-icon class="material-icons">check</md-icon>
                </span>SALVAR
            </md-button>
        </md-card-actions>
    </form>
</md-card>
</template>

<script>
import Notify from '@/config/mixins/notify'
import HeaderForm from '@/pages/Layout/Extra/HeaderForm'

export default {
    components: {
        HeaderForm
    },
    data() {
        return {
            dados: {
                desenvolvedor: 0
            },
            listGrupo: [],
            grupos: ['X'],
            grupo: '',
            errors: {}
        }
    },

    created() {
        this.getPermissao()
        this.getGrupo()
    },

    mixins: [Notify],

    methods: {

        getPermissao() {
            this.$http.get(this.$urlAPI + 'permissoes/' + this.$route.params.id)
                .then(response => {
                    if (response.data.status) {
                        this.dados = response.data.dados[0];
                        this.grupo = response.data.dados[0].grupo;
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        getGrupo() {
            this.$http.get(this.$urlAPI + 'permissoes', this.dados)
                .then(response => {
                    this.listGrupo = response.data.grupo
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },

        autoCompleteGrupo(searchTerm) {            
            this.grupos = new Promise(resolve => {
                if (!searchTerm) {
                    resolve(this.listGrupo.map(x => x.name));
                } else {
                    const term = searchTerm.toLowerCase();
                    this.grupos = this.listGrupo.filter(({
                        name
                    }) => {
                        return name.toLowerCase().includes(term);
                    }).map(x => x.name);
                    resolve(this.grupos);
                }
            });
        },

        getSelectedGrupo() {
            let customer = this.grupo
            this.dados.grupo_permissao_id = this.listGrupo.filter(function (e) {
                return e.name === customer
            })[0].id
        },

        update() {
            this.$http.put(this.$urlAPI + 'permissoes/' + this.dados.id, this.dados)
                .then(response => {
                    if (response.data.status) {
                        this.$router.push({
                            name: 'permissaoRead'
                        });
                        this.success(response.data.message)
                        this.errors = ''
                    } else if (response.data.errors) {
                        this.errors = response.data.errors
                        let erros = ''
                        for (let erro of Object.values(response.data.errors)) {
                            erros += "<li>" + erro + "</li>";
                        }
                        this.danger("<ul>" + erros + "</ul>")
                    } else {
                        this.danger(response.data.message)
                        this.errors = ''
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
        },
    }
};
</script>

<style scoped>

</style>
